import catchContent from "../catchContent/"
import navTab from '../navTab/'
export default {
  name: "contentWarp",
  components:{
    catchContent,
    navTab
  }
}



// WEBPACK FOOTER //
// ./src/layout/contentWarp/contentWarp.js